<div>
    <div class="flex-row flex justify-between text-primary">
        <div>
            <button type="button" mat-icon-button (click)="logStorage()" [matTooltip]="'Info log'">
                <i class="fa fal fa-info-circle"></i>
            </button>
            <button type="button" mat-icon-button (click)="reset()" [matTooltip]="'Zahodit změny'">
                <i class="fa fal fa-trash"></i>
            </button>
        </div>

        <div>
            <button type="button" class="mr-4" mat-icon-button (click)="back()">
                <i class="fa-lg fas fa-arrow-left"></i>
            </button>
            <button type="button" mat-icon-button (click)="dialogRef.close()">
                <i class="fa-lg fas fa-times"></i>
            </button>
        </div>
    </div>


    <div class=" justify-between items-center w-full -mt-10 mb-12 px-32 hidden md:flex">
<!--        <div class="step-it em flex flex-col items-center w-[80px]">-->
<!--            <div class="w-10 h-10 rounded-full flex items-center justify-center relative"-->
<!--                 [ngClass]="{-->
<!--                        'bg-green-500': notificationWizard.step > 0,-->
<!--                        'bg-slate-400': !(notificationWizard.step > 0)}"-->
<!--            >-->
<!--            <span class="text-white">-->
<!--                <i class="fa-lg fas fa-bell"></i>-->
<!--            </span>-->
<!--            </div>-->
<!--            <div class="text-xs md:text-base mt-2">Kanál</div>-->
<!--        </div>-->
<!--        <div class="step-line flex-1 flex items-center justify-center mb-6">-->
<!--            <div class="w-full h-1 rounded-full"-->
<!--                 [ngClass]="{-->
<!--                        'bg-green-500': notificationWizard.step > 0,-->
<!--                        'bg-slate-400': !(notificationWizard.step > 0)}">-->
<!--            </div>-->
<!--        </div>-->
<!--        <div class="step-it em flex flex-col items-center w-[80px]">-->
<!--            <div class="w-10 h-10 rounded-full flex items-center justify-center relative"-->
<!--                 [ngClass]="{-->
<!--                        'bg-green-500': notificationWizard.step > 1,-->
<!--                        'bg-slate-400': !(notificationWizard.step > 1)}">-->
<!--            <span class="text-white">-->
<!--                <i class="fa-lg fas fa-briefcase"></i>-->
<!--            </span>-->
<!--            </div>-->
<!--            <div class="text-xs md:text-base mt-2">Cíl. skupina</div>-->
<!--        </div>-->
<!--        <div class="step-line flex-1 flex items-center justify-center mb-6">-->
<!--            <div class="w-full h-1 rounded-full"-->
<!--                 [ngClass]="{-->
<!--                        'bg-green-500': notificationWizard.step > 1,-->
<!--                        'bg-slate-400': !(notificationWizard.step > 1)}"></div>-->
<!--        </div>-->
        <div class="step-it em flex flex-col items-center w-[80px]">
            <div class="w-10 h-10  rounded-full flex items-center justify-center relative"
                 [ngClass]="{
                        'bg-green-500': notificationWizard.step > 0,
                        'bg-slate-400': !(notificationWizard.step > 0)}">
            <span class="text-white">
                <i class="fa-lg fas fa-filter"></i>
            </span>
            </div>
            <div class="text-xs md:text-base mt-2">Filtrace</div>
        </div>
        <div class="step-line flex-1 flex items-center justify-center mb-6">
            <div class="w-full h-1 rounded-full"
                 [ngClass]="{
                        'bg-green-500': notificationWizard.step > 0,
                        'bg-slate-400': !(notificationWizard.step > 0)}"></div>
        </div>
        <div class="step-it em flex flex-col items-center w-[80px]">
            <div class="w-10 h-10 rounded-full flex items-center justify-center relative"
                 [ngClass]="{
                        'bg-green-500': notificationWizard.step > 1,
                        'bg-slate-400': !(notificationWizard.step > 1)}">
            <span class="text-white">
                <i class="fa-lg fas fa-font"></i>
            </span>
            </div>
            <div class="text-xs md:text-base mt-2">Obsah</div>
        </div>
        <div class="step-line flex-1 flex items-center justify-center mb-6">
            <div class="w-full h-1 rounded-full"
                 [ngClass]="{
                        'bg-green-500': notificationWizard.step > 1,
                        'bg-slate-400': !(notificationWizard.step > 1)}"></div>
        </div>
        <div class="step-it em flex flex-col items-center w-[80px]">
            <div class="w-10 h-10 rounded-full flex items-center justify-center relative"
                 [ngClass]="{
                        'bg-green-500': notificationWizard.step > 2,
                        'bg-slate-400': !(notificationWizard.step > 2)}">
            <span class="text-white">
                <i class="fa-lg fas fa-check"></i>
            </span>
            </div>
            <div class="text-xs md:text-base mt-2">Souhrn</div>
        </div>
    </div>


    <div class="w-full h-full text-lg text-center">

        <ng-container *ngIf="notificationWizard.step === notificationWizardSteps.Filter">
            <app-notification-wizard-filter (saveEmitter)="nextStep()"></app-notification-wizard-filter>
        </ng-container>

        <ng-container *ngIf="notificationWizard.step === notificationWizardSteps.Text">
            <app-notification-wizard-text (saveEmitter)="nextStep()"></app-notification-wizard-text>
        </ng-container>

        <ng-container *ngIf="notificationWizard.step === notificationWizardSteps.Summaray">
            <app-notification-wizard-summary (saveEmitter)="nextStep()"></app-notification-wizard-summary>
        </ng-container>

    </div>
</div>
